import React, { useState, useEffect } from 'react';
import Axios from 'axios';

import * as Antd from 'antd';

export const UserRoleSelect = props => {
    const [items, setItems] = useState([]);

    const fetchItems = async () => {
        try {
            let response = await Axios.get(`${process.env.REACT_APP_API_BASE_URI}/api/user-roles`);
            return response.data;
        } catch (err) {

        }
    }

    const init = async () => {
        let items = await fetchItems();
        setItems(items);
    }

    useEffect(() => {
        init();
    }, [])

    return (
        <Antd.Select            
            {...props}
        >            
            {items.map((child, idx) => {
                return <Antd.Select.Option key={idx} value={child.code}>{child.code}</Antd.Select.Option>
            })}
        </Antd.Select>
    )
}